import React, { useState } from 'react';
import { doc, updateDoc, arrayUnion } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../AuthContext';
import '../stylesheets/AddAdress.css';

const AddAdress = ({ address, setAddress }) => {
  const { user } = useAuth();
  const [city, setCity] = useState('');
  const [neighborhood, setNeighborhood] = useState('');
  const [addressText, setAddressText] = useState('');
  const [property, setProperty] = useState('');
  const [additionalInfo, setAdditionalInfo] = useState('');
  const [error, setError] = useState('');
  const [otherEnabled, setOtherEnabled] = useState(false); // Controla el estado del input "Otro"

  const handlePropertyChange = (event) => {
    const selectedProperty = event.target.value;

    if (selectedProperty === 'Otro') {
      setProperty(''); // Dejar el campo "Otro" vacío para que sea editable
      setOtherEnabled(true);
    } else {
      setProperty(selectedProperty);
      setOtherEnabled(false); // Deshabilitar el input "Otro" si no está seleccionado
    }
  };

  const handleSaveAddress = async (event) => {
    event.preventDefault();

    // Verificar que los campos obligatorios estén llenos
    if (!city || !neighborhood || !addressText || !property) {
      setError('Por favor, complete todos los campos obligatorios.');
      return;
    }

    if (user) {
      const userDocRef = doc(db, 'users', user.uid);
      try {
        await updateDoc(userDocRef, {
          ShippingInfo: arrayUnion({
            city,
            neighborhood,
            address: addressText,
            property,
            additionalInfo, // Campo opcional
          }),
        });
        setAddress(false); // Cerrar la ventana de dirección después de guardar
        setCity('');
        setNeighborhood('');
        setAddressText('');
        setProperty('');
        setAdditionalInfo('');
        setError(''); // Limpiar el mensaje de error
      } catch (error) {
        console.error('Error al guardar la dirección en Firestore:', error);
        setError('Error al guardar la dirección. Intente de nuevo.');
      }
    }
  };

  return (
    <>
      {address && (
        <div className='Address-win-cont'>
          <div className='blur'></div>
          <div className='Address-cont'>
            <div className='Address-title-cont'>
              <h1 className='Address-title'>Agregar nueva dirección</h1>
              <button
                className='close-btn'
                onClick={(event) => {
                  event.preventDefault();
                  setAddress(false);
                }}
              >
                x
              </button>
            </div>
            <form onSubmit={handleSaveAddress}>
              <div className='field-cont'>
                <div className='field-container'>
                  <div className='txt-container'>
                    <h2 className='field-txt'>Ciudad</h2>
                  </div>
                  <div className='input-container'>
                    <input
                      type='text'
                      className='input'
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                      required
                    />
                  </div>
                </div>
                <div className='field-container'>
                  <div className='txt-container'>
                    <h2 className='field-txt'>Barrio</h2>
                  </div>
                  <div className='input-container'>
                    <input
                      type='text'
                      className='input'
                      value={neighborhood}
                      onChange={(e) => setNeighborhood(e.target.value)}
                      required
                    />
                  </div>
                </div>
                <div className='field-container'>
                  <div className='txt-container'>
                    <h2 className='field-txt'>Dirección</h2>
                  </div>
                  <div className='input-container'>
                    <input
                      type='text'
                      className='input'
                      value={addressText}
                      onChange={(e) => setAddressText(e.target.value)}
                      required
                    />
                  </div>
                </div>
              </div>
              <div className='Propertys-type-cont'>
                <div className='Property-type-cont'>
                  <label>
                    <input
                      type='radio'
                      value='Casa'
                      checked={property === 'Casa'}
                      onChange={handlePropertyChange}
                    />
                    Casa
                  </label>
                </div>
                <div className='Property-type-cont'>
                  <label>
                    <input
                      type='radio'
                      value='Apartamento'
                      checked={property === 'Apartamento'}
                      onChange={handlePropertyChange}
                    />
                    Apartamento
                  </label>
                </div>
                <div className='Property-type-cont'>
                  <label>
                    <input
                      type='radio'
                      value='Conjunto residencial'
                      checked={property === 'Conjunto residencial'}
                      onChange={handlePropertyChange}
                    />
                    Conjunto residencial
                  </label>
                </div>
                <div className='Property-type-cont'>
                  <label>
                    <input
                      type='radio'
                      value='Otro'
                      checked={property === ''}
                      onChange={handlePropertyChange}
                    />
                    Otro
                    <input
                      type='text'
                      className='other-input-container'
                      value={otherEnabled ? property : ''}
                      onChange={(e) => setProperty(e.target.value)}
                      disabled={!otherEnabled}
                      required={otherEnabled}
                    />
                  </label>
                </div>
              </div>
              <div className='indications-cont'>
                <h2 className='indications-title'>Indicaciones adicionales</h2>
                <textarea
                  name='indications'
                  className='indications'
                  value={additionalInfo}
                  onChange={(e) => setAdditionalInfo(e.target.value)}
                ></textarea>
              </div>
              {error && <p className='error-message'>{error}</p>}
              <div className='indications-btn-cont'>
                <button type='submit'>Aceptar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default AddAdress;
